import { SortingKindEnum } from '../../utils/interfaces';

export const incidentHeaders = [
  {
    col: 'Name',
    text: 'Incident Name',
    sortable: true,
    sortKind: SortingKindEnum.NAME,
    order: 1,
    align: 'left',
  },
  {
    col: 'Description',
    text: 'Description',
    sortable: false,
    order: 2,
    align: 'left',
  },
  {
    col: 'Creator',
    text: 'Creator',
    sortable: true,
    sortKind: SortingKindEnum.CREATOR,
    order: 3,
    align: 'left',
  },
  {
    col: 'Type',
    text: 'Incident Type',
    sortable: true,
    sortKind: SortingKindEnum.TYPE,
    order: 4,
    align: 'left',
  },
  {
    col: 'Date',
    text: 'Date',
    sortable: true,
    sortKind: SortingKindEnum.DATE,
    order: 5,
    align: 'right',
  },
  { col: 'Icon', text: '', sortable: false, order: 6, align: 'right' },
];
